export default __webpack_public_path__ + "static/media/Wham-Last-Christmas.7c7ac1fe.mp3";